import Vue from 'vue'
import App from './App.vue'
import store from './store/index.js'
import Vuelidate from 'vuelidate'
import VueYandexMetrika from 'vue-yandex-metrika' 


Vue.use(Vuelidate)

Vue.use(VueYandexMetrika, {
    id: 72948019,
    env: "production",
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true
    // other options
})

Vue.config.productionTip = false


new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
